<mat-card>
    <mat-card-content>
        <!-- Title -->
        <h1>Device Info</h1>

        <!-- Device Info -->
        <div class="device-info">
            <div class="field os">
                <div class="label">OS</div>
                <div class="value" data-cy="os">{{ deviceInfo?.os }}</div>
              </div>
            <div class="field browser">
              <div class="label">Browser</div>
              <div class="value" data-cy="browser">{{ deviceInfo?.browser }} {{ deviceInfo?.browser_version }}</div>
            </div>
          </div>
    </mat-card-content>
  </mat-card>